export default __webpack_public_path__ + "static/media/img-gtl-du3@2x.fa062c09.png";